<template>
  <div
    style="background-color: #ebeffc; width: 100vw; height: 100vh"
    @click="isType = false"
  >
    <div class="login_bg">
      <div
        class="small_box"
        :style="{ width: computedw(1749), height: computedH(954) }"
      >
        <div class="left">
          <div class="bottom_box" :style="{ bottom: computedH(19) }">
            <img
              class="btn"
              :style="{ width: computedw(300) }"
              @click="tologin"
              src="@/assets/login/btn.png"
              alt=""
            />
            <div style="display: flex; justify-content: center">
              <div style="display: flex; align-items: center">
                <img
                  class="call"
                  :style="{ width: computedw(32) }"
                  src="@/assets/login/call_icon.png"
                  alt=""
                />
                <span>053283859555</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div style="position: relative">
            <div class="type_box" @click.stop="isType = !isType">
              <img src="@/assets/login/user_icon.png" alt="" /><span
                class="type_name"
                >{{ pageType == 2 ? "企业登录" : "猎头登录" }}</span
              >
              <img src="@/assets/login/arrow_down.png" alt="" />
            </div>
            <div class="typePopup" v-show="isType" @click.stop>
              <div
                :class="'typeItem ' + (pageType == 2 ? 'selectType' : '')"
                @click="cahngeType(2)"
              >
                企业登录
              </div>
              <div :class="'typeItem ' + (pageType == 1 ? 'selectType' : '')">
                猎头登录
              </div>
            </div>
          </div>
          <div class="right_content">
            <div class="title">欢迎使用上啥班云管家</div>
            <el-form
              ref="formRef"
              :model="formData"
              :rules="rules"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-form-item prop="userName">
                <el-input
                  class="input"
                  v-model="formData.userName"
                  placeholder="请输入账号"
                >
                  <template #prefix>
                    <img
                      style="width: 21px"
                      src="@/assets/login/userName_icon.png"
                      alt=""
                    />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="passWord">
                <el-input
                  class="input"
                  v-model="formData.passWord"
                  :type="isBrowse ? 'password' : 'text'"
                  placeholder="请输入密码"
                >
                  <template #prefix>
                    <img
                      style="width: 21px"
                      src="@/assets/login/lock_icon.png"
                      alt=""
                    />
                  </template>
                  <template #suffix>
                    <img
                      style="width: 21px"
                      v-if="isBrowse"
                      @click="isBrowse = false"
                      src="@/assets/login/browse_off.png"
                      alt=""
                    />
                    <img
                      style="width: 21px"
                      v-else
                      @click="isBrowse = true"
                      src="@/assets/login/browse.png"
                      alt=""
                    />
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <div class="agreement_box">
              <img
                v-show="!isAgreement"
                @click="isAgreement = true"
                style="width: 21px; margin-right: 12px"
                src="@/assets/login/checkoutNone_icon.png"
                alt=""
              />
              <img
                v-show="isAgreement"
                @click="isAgreement = false"
                style="width: 21px; margin-right: 12px"
                src="@/assets/login/checkout_icon.png"
                alt=""
              />
              <div>
                打勾表示您已阅读并同意
                <a @click="goTo" style="color: rgb(56, 96, 226)"
                  >《上啥班云管家用户服务协议》</a
                >以及
                <a @click="goTo1" style="color: rgb(56, 96, 226)"
                  >《上啥班云平台用户隐私协议》</a
                >
              </div>
            </div>
            <el-button class="login_btn" @click="handleLogin">登录</el-button>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 16px;
                font-size: 16px;
                font-weight: 400;
                color: #3860e2;
              "
            >
              <a @click="tologin">立即联系加入我们</a>
              <a @click="topassword">忘记密码？</a>
            </div>
          </div>
          <div class="EORI_box">
            © 2023 青岛上啥班网络科技有限公司 All rights reserved <br />
            鲁ICP备16013214号
          </div>
          <div v-show="isTost" class="tost_box">{{ tostMsg }}</div>
        </div>
      </div>
    </div>
    <joinPopup ref="joinPopup1" />
  </div>
</template>
<script>
import { encrypt, decrypt } from "@/utils/rsaEncrypt";
import Config from "@/config";
import { getVerify, login, contactUs } from "@/api/common";
import { baseUrl5 } from "@/api/baseUrl";
import Cookies from "js-cookie";
import { setStore } from "@/utils/util";
import joinPopup from "@/components/loginComponents/joinPopup.vue";
import  emojiList  from "@/utils/emojiList";

export default {
  name: "Login",
  components: { joinPopup },
  data() {
    const validateuserName = (rule, value, callback) => {
      // let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      console.log(value);
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    const validatePassWord = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value !== this.formData.passWord) {
        // callback(new Error("Two inputs don't match!"))
      } else {
        callback();
      }
    };
    return {
      tostMsg: "",
      pageType: 1,
      isType: false,
      isTost: false,
      formData: {
        userName: "",
        passWord: "",
      },
      isBrowse: true,
      isAgreement: false,
      rules: {
        userName: [{ validator: validateuserName, trigger: ["blur"] }],
        passWord: [{ validator: validatePassWord, trigger: ["blur"] }],
      },
      imgUrl: baseUrl5 + "/common/getVerify?" + Math.random(),
    };
  },
  mounted() {
    console.log(emojiList);
    
    this.changeImg();
    console.log(this);
    this.pageType = this.$route.query.pageType
      ? this.$route.query.pageType * 1
      : 1;
    console.log(window.location.host);
  },
  methods: {
    cahngeType(type) {
      this.isType = false;
      if (window.location.host == "crm.shangshaban.com") {
        location.replace("https://crme.shangshaban.com/login");
      } else {
        if (window.location.host == "localhost:9081") {
          location.replace("http://localhost:9090/login");
        } else {
          location.replace("http://test-crm.shangshaban.com:9052/login");
        }
      }
    },
    goTo() {
      this.$router.push({ path: "/agreementsUser" });
    },
    goTo1() {
      this.$router.push({ path: "/privacyPolicy" });
    },
    showTost(msg) {
      this.tostMsg = msg;
      this.isTost = true;
      let timer = setTimeout(() => {
        this.tostMsg = "";
        this.isTost = false;
        clearTimeout(timer);
      }, 2000);
    },
    tologin() {
      console.log(this.$refs.joinPopup1);
      this.$refs.joinPopup1.show();
    },
    topassword() {
      this.$router.push({ path: "/forgetpassword" });
    },
    computedH(num) {
      let height = (num / 1080) * 100 + "vh";
      return height;
    },
    computedw(num) {
      let width = (num / 1920) * 100 + "vw";
      return width;
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    changeImg() {
      // this.imgUrl = baseUrl5 + "/common/getVerify?" + Math.random();
      this.getCookie();
    },

    getCookie() {
      const username = Cookies.get("username");
      let password = Cookies.get("password");
      // 保存cookie里面的加密后的密码
      this.cookiePass = password === undefined ? "" : password;
      password = password === undefined ? this.formData.passWord : password;
      // this.formData = {
      //   userName: username === undefined ? this.formData.userName : username,
      //   passWord: password,
      // };
    },
    handleLogin() {
      const user = {
        username: this.formData.userName,
        password: this.formData.passWord,
        rememberMe: this.isAgreement,
        type: this.pageType,
        // code: this.loginForm.code,
        uuid: Cookies.get("verifyCodeId"),
      };
      if (user.password !== this.cookiePass) {
        user.password = encrypt(user.password);
      }
      this.loading = true;
      let reqData = {
        phone: user.username,
        password: decrypt(user.password),
        type: this.pageType,
        // verifyCode: user.code,
        verifyCodeId: Cookies.get("verifyCodeId"),
      };
      console.log(reqData);
      if (!reqData.phone && !reqData.password) {
        this.showTost("请填写完整信息");
        return;
      }
      if (!reqData.phone) {
        this.showTost("请填写您的账号");
        return;
      }
      if (!reqData.password) {
        this.showTost("请填写您的密码");
        return;
      }
      if (!this.isAgreement) {
        this.showTost("请确认并同意隐私政策后提交");
        return;
      }
      login(reqData)
        .then((res) => {
          if (res.no == 1) {
            this.loading = false;
      
            this.$message({
              message: res.msg,
              type: "success",
            });
            window.isshow = true;
            this.$store.dispatch("Login", res);
            setStore(
              "visitedViews",
              JSON.stringify([
                {
                  path: "/home",
                  name: "首页",
                  affix: true,
                },
              ])
            );
            this.$router.push({ path: "/home" });
            // this.passDialogSwitch = false;
            location.reload();
          } else {
            this.showTost(res.msg);
            // this.$message({
            //   message: res.msg,
            //   type: "error",
            // });
            this.loading = false;
            this.changeImg();
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message({
            message: "请求错误",
            type: "error",
          });
          this.changeImg();
        });
    },
  },
};
</script>
<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  border: none;
  -webkit-text-fill-color: #333;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
<style lang="scss" scoped>
.tost_box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 222px;
  height: 38px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 38px;
  text-align: center;
  background-color: #333333;
  border-radius: 3px;
}

.typePopup {
  user-select: none;
  position: absolute;
  width: 135px;
  top: 32px;
  right: 30px;
  // height: 64px;
  padding: 6px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);

  .typeItem {
    height: 34px;
    line-height: 34px;
    background: #ffffff;
    border-radius: 3px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
  }

  .typeItem:hover {
    background: #ebeffc;
    color: #3860e2;
  }

  .selectType {
    color: #3860e2;
    background: #ebeffc;
  }
}

.login_bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.small_box {
  min-width: 1180px;
  display: flex;
  border-radius: 2.8125rem;
  overflow: hidden;
}

.left {
  position: relative;
  width: 50%;

  background-image: url(../assets/login/left_bg.png);

  background-position: center center, center top, center bottom;
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: 100% auto, 100% 50%, 100% 50%;

  .bottom_box {
    position: absolute;
    // bottom:19px;
    color: #fff;
    font-size: 1.75rem;
    left: 50%;
    transform: translateX(-50%);

    .btn {
      min-width: 288.66px;
    }

    .call {
      min-width: 21.33px;
    }
  }
}

.right {
  position: relative;
  text-align: center;
  width: 50%;
  background-color: #fff;

  .type_box {
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: end;
    margin-right: 24px;
    margin-top: 24px;

    img {
      flex-basis: 21px;
      width: 21px;
      height: 21px;
      margin-right: 5px;
    }

    .type_name {
      width: 90px;
      height: 24px;
      font-size: 19px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
      text-align: left;
    }
  }

  .right_content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 409px;

    .title {
      text-align: left;
      width: 400px;
      height: 37px;
      font-size: 32px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 37px;
      margin-bottom: 32px;
    }

    .agreement_box {
      display: flex;
      align-items: center;
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-align: left;
      margin-top: 32px;
    }

    .login_btn {
      width: 409px;
      height: 47px;
      background: #3860e2;
      border-radius: 7px 7px 7px 7px;
      font-size: 24px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 37px;
    }
  }

  .EORI_box {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
    width: 374px;
    height: 55px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }
}
</style>
<style lang="scss">
.login_bg {
  .el-input__inner {
    width: 409px;
    height: 47px !important;
    background: #ffffff;
    border-radius: 7px 7px 7px 7px;
    border: 1px solid #dcdcdc;
    margin-top: 3px;
  }

  .el-input__prefix {
    display: flex;
    align-items: center;
  }

  .el-input__suffix {
    display: flex;
    align-items: center;
  }

  .el-input__suffix-inner {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue